import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sagaMonitorApi } from '../api/sagaMonitorApi';

/**
 * POST /api/eraf/saga-monitor/instances/{id}/resume — 사가 재시작 (SAGA_MONITOR_RETRY)
 * 성공 시 목록·상세·단계 쿼리 무효화
 */
export function useResumeSaga() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => sagaMonitorApi.resumeInstance(id),
    onSuccess: (_data, id) => {
      void queryClient.invalidateQueries({ queryKey: ['saga-monitor', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['saga-monitor', 'detail', id] });
      void queryClient.invalidateQueries({ queryKey: ['saga-monitor', 'steps', id] });
      void queryClient.invalidateQueries({ queryKey: ['saga-monitor', 'summary'] });
    },
  });
}
